export default "__VITE_ASSET__CsJhlWGm__"